import React from 'react';

export default class ChatWindowHeader extends React.Component {
    constructor(props) {
        super(props);

        this.reRenderTime = 250;
    }

    isConnecting() {
        if (!this.props.isConnecting) {
            return <div className='header__logo'></div>
        }

        setTimeout(() => {
            this.isConnecting();
        }, this.reRenderTime);

        return <div className='header__loading'>Connecting<div></div><div></div><div></div></div>
    }

    render() {
        return(
            <div className='chat-window__header'>
                <button className='header__minimize chat-minimize' title='Minimize the chat window.' aria-label='Minimize the chat window. This will keep your chat active.'></button>
                {this.isConnecting()}
                <button className='header__close chat-close' title='Close the chat window.' aria-label='Close the chat window. This will end your chat session.'></button>
            </div>
        )
    }
}